import { bool, shape, string } from 'prop-types';

const tmsInternalNoteActivityShape = shape({
  initiatorName: string,
  note: string,
  loadId: string,
  eventId: string,
  eventTime: string,
  eventType: string,
  isAutomated: bool,
  city: string,
  state: string,
});

export default tmsInternalNoteActivityShape;
